var map = {
	"./ADMINISTRATIVO.svg": 73187,
	"./ANALISE.svg": 11454,
	"./APAC.svg": 74504,
	"./BUSCA_ATIVA.svg": 84117,
	"./CONECTA.svg": 864,
	"./EEG.svg": 67164,
	"./ELETROCARDIOGRAFIA.svg": 99080,
	"./ESPIROMETRIA.svg": 79905,
	"./ESTOMATO.svg": 85809,
	"./EXAMES.svg": 20378,
	"./GESTAOPACS.svg": 60649,
	"./HELPDESK.svg": 5781,
	"./MENSAGENS.svg": 59992,
	"./OAUTH2.svg": 8026,
	"./OXIGENOTERAPIA.svg": 3106,
	"./POLISSONOGRAFIA.svg": 36955,
	"./RSE.svg": 10787,
	"./TELEATENDIMENTO.svg": 19427,
	"./TELECONSULTORIAS.svg": 49099,
	"./TELEDERMATO.svg": 34609,
	"./TELEEDUCACAO.svg": 10376,
	"./TFD.svg": 55023,
	"./TFDPASSAGENS.svg": 3644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22171;